var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:'mot-expert '+_vm.type},[_c('h4',[_vm._v("Le mot de l'expert")]),_c('p',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }